"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saleAddressFactory = void 0;
const Factory = require("factory.ts");
const Mocks = require("../../../mocks");
exports.saleAddressFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    name: Mocks.persona.full_name,
    address_1: Mocks.address.line1,
    address_2: Mocks.address.line2,
    city: Mocks.address.city,
    state_or_province: Mocks.address.state,
    postal_code: Mocks.address.zip,
    country: Mocks.address.country,
    dma_id: null,
    email: Mocks.persona.email
});
